import { render } from "./ValidationFieldSetWithoutLayout.vue?vue&type=template&id=6ed46e08&scoped=true&ts=true"
import script from "./ValidationFieldSetWithoutLayout.vue?vue&type=script&lang=ts"
export * from "./ValidationFieldSetWithoutLayout.vue?vue&type=script&lang=ts"

import "./ValidationFieldSetWithoutLayout.vue?vue&type=style&index=0&id=6ed46e08&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed46e08"]])

export default __exports__